<template>
  <div class="clearfix header-container">
    <div
      class="header-common"
      v-bind:style="{borderBottom: borderBottom,backgroundColor: backgroundColor}"
    >
      <b-row  >
        <b-col class="back" cols="3" >
          <div @click="onBack" v-show="hasBackBtn">
            <img class="back-img" src="../assets/img/fanhui.png" width="13">
           {{$t('m.header.back')}}
          </div>
           <div v-show="AddressBtn" @click="addressClick" class="address">
           {{address}}<img class="back-img" src="../assets/img/xiajiantou.png" width="13">
          </div>
        </b-col>
        <b-col class="title">{{headerTitle}}</b-col>
        <b-col class="other" cols="3">
          <div @click="onRightBtnClick">
            {{rightTitle}}
            <b-img :src="rightIconSrc"  v-if="iconShow" width="20"/>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  props: {
    borderBottom: {
      type: String,
      default: "1px solid #e5e5e5"
    },
    backgroundColor: {
      type: String,
      default: "white"
    },
    hasBackBtn: {
      type: Boolean,
      default: true
    },
    AddressBtn: {
      type: Boolean,
      default: false
    },
    headerTitle: {
      type: String,
      default: ""
    },
    rightTitle: {
      type: String,
      required: false,
      default: ""
    },
    rightIconSrc: undefined,
    onRightBtnClick: {
      type: Function,
      default: function() {}
    },
    change: {
      type: Function,
      default: function() {}
    },
    addressClick: {
      type: Function,
      default: function() {}
    },
    address: {
      type: String,
      default: ""
    },
    iconShow:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    onBack: function() {
      window.history.back();
      localStorage.removeItem("provinceName");
    }
  }
};
</script>
<style scoped>
.header-container {
  height: 50px;
  padding: 0px;
}
.header-common {
  z-index: 999;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 50px;
  z-index: 9999;
}

.header-common .row{
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-common .back {
  text-align: left;
  margin-left: 15px;
}
.header-common .back img {
  position: relative;
  top: -1px;
}
.header-common .address{
  /* text-align: left;
  font-size: 15px;
  position:absolute; */
   display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.header-common .title {
  font-size: 3.5vw;
  color: #424242;
  text-align: center;
}
.header-common .other div {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
